import { atom } from 'jotai'
import { BvnkNetworkConnectionsResponse } from 'types/bvnkNetwork'

export const bvnkNetworkConnectionsAtom = atom<BvnkNetworkConnectionsResponse>({})
export const isFetchingConnectionsAtom = atom(false)
export const isFetchingConnectionsErrorAtom = atom(false)
